import React from 'react';
import { Database, Zap, Search } from 'lucide-react';

const SqlWizard = ({ data = {}, setData }) => {
  
  const handleToggle = (option) => {
    setData({
      ...data,
      sqlHanaOpts: { ...data.sqlHanaOpts, [option]: !data.sqlHanaOpts[option] }
    });
  };

  return (
    <div className="animate-in fade-in duration-300 text-left w-full space-y-6">
      
      {/* NOTA */}
      <div className="bg-blue-900/10 border-l-4 border-blue-600 p-5 rounded-r-3xl flex gap-4 items-start">
        <div className="bg-blue-600 p-2 rounded-xl text-white shrink-0">
          <Database size={18} />
        </div>
        <div>
          <p className="text-[11px] text-blue-400 font-black uppercase tracking-widest mb-1">
            SQL Optimizer Guide
          </p>
          <p className="text-[11px] text-slate-400 leading-relaxed">
            Pegá tu sentencia SELECT en el campo inferior. El motor la analiza y genera una versión 
            optimizada para <strong>SAP HANA</strong> con pushdown logic, eliminación de FOR ALL ENTRIES 
            ineficientes, índices sugeridos y sintaxis Open SQL moderna lista para S/4HANA.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        
        {/* COLUMNA 1 */}
        <div className="bg-[#0F172A] p-6 rounded-[28px] text-white border-b-4 border-blue-500 space-y-4">
          <label className="text-[10px] font-black text-blue-400 uppercase flex items-center gap-2 border-b border-slate-800 pb-2">
            <Database size={14}/> Execution Environment
          </label>
          
          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">Target Database</label>
            <select className="w-full p-2.5 bg-slate-800 border-none rounded-xl text-xs font-bold text-white outline-none focus:ring-2 focus:ring-blue-500"
              value={data.sqlTargetDB || 'HANA'} onChange={e => setData({...data, sqlTargetDB: e.target.value})}>
              <option value="HANA">SAP HANA (Column Store)</option>
              <option value="CLASSIC">Classic DB (AnyDB)</option>
              <option value="S4HANA">S/4HANA (Universal Journal)</option>
            </select>
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">Optimization Priority</label>
            <select className="w-full p-2.5 bg-slate-800 border-none rounded-xl text-xs font-bold text-white outline-none focus:ring-2 focus:ring-blue-500"
              value={data.sqlStrategy || 'Performance'} onChange={e => setData({...data, sqlStrategy: e.target.value})}>
              <option value="Performance">Execution Speed (Best for Jobs)</option>
              <option value="Memory">Low RAM Footprint</option>
              <option value="HANA_READY">Pushdown Logic (HANA Only)</option>
            </select>
          </div>

          <div>
            <label className="text-[9px] font-bold text-slate-400 uppercase block mb-1">Main Tables Involved</label>
            <div className="relative">
              <Search size={14} className="absolute left-3 top-3 text-slate-500"/>
              <input type="text"
                className="w-full p-2.5 pl-9 bg-slate-800 border border-slate-700 rounded-xl text-xs font-mono uppercase text-blue-200 placeholder:text-slate-600 outline-none focus:border-blue-400"
                placeholder="Ej: BKPF, BSEG, ACDOCA..."
                value={data.sqlTables || ''}
                onChange={e => setData({...data, sqlTables: e.target.value})} />
            </div>
          </div>
        </div>

        {/* COLUMNA 2 */}
        <div className="bg-[#0F172A] p-6 rounded-[28px] text-white border-b-4 border-blue-500 space-y-4">
          <label className="text-[10px] font-black text-blue-400 uppercase flex items-center gap-2 border-b border-slate-800 pb-2">
            <Zap size={14}/> Advanced Tuning Switches
          </label>

          <div className="space-y-3">
            {[
              { key: "inline",     label: "Inline Data (@DATA)",     desc: "Declaraciones inline en SELECT" },
              { key: "faeToJoin",  label: "Convert FAE to Join",     desc: "Reemplaza FOR ALL ENTRIES por JOIN" },
              { key: "strict",     label: "Strict SQL Mode",         desc: "Optimizador de segundo nivel HANA" },
              { key: "noSelectStar", label: "Eliminar SELECT *",     desc: "Proyección explícita de campos" },
              { key: "addIndex",   label: "Sugerir Índices",         desc: "Índices secundarios recomendados" },
            ].map((opt) => (
              <label key={opt.key}
                className={`flex items-center gap-3 cursor-pointer p-3 rounded-xl border transition-all ${
                  data.sqlHanaOpts?.[opt.key]
                    ? 'bg-blue-600/20 border-blue-500/50'
                    : 'bg-slate-800 border-slate-700 hover:border-slate-600'
                }`}>
                <div className="flex-1">
                  <p className={`text-[10px] font-black uppercase ${data.sqlHanaOpts?.[opt.key] ? 'text-blue-400' : 'text-slate-400'}`}>
                    {opt.label}
                  </p>
                  <p className="text-[9px] text-slate-500">{opt.desc}</p>
                </div>
                <input type="checkbox" className="w-4 h-4 rounded shrink-0"
                  checked={data.sqlHanaOpts?.[opt.key] || false}
                  onChange={() => handleToggle(opt.key)} />
              </label>
            ))}
          </div>

          <p className="text-[9px] text-slate-600 leading-tight pt-2 border-t border-slate-800">
            * Strict SQL requiere SAP NetWeaver 7.50+ para optimizaciones de segundo nivel en HANA.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SqlWizard;